import { content } from "../../config/content.js";
import { buildAnimatedHeading } from "../HeroTitleAnimation.js";
import { buildSectionPillRow } from "../components/SectionPill.js";

const cursorIcon = `<svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M5 3l7 17 2.5-7.5L22 10 5 3z" fill="#fff" stroke="#0a0a0f" stroke-width="1.4" stroke-linejoin="round"/>
</svg>`;

const CELL_COUNT = 20;

function renderVisual(icons) {
  const byIndex = new Map(icons.map((icon) => [icon.at, icon]));

  const cells = Array.from({ length: CELL_COUNT }, (_, i) => {
    const icon = byIndex.get(i);
    if (!icon) return `<span class="advantage__cell" style="--cell-i: ${i}"></span>`;
    const center = icon.center ? " advantage__cell--center" : "";
    return `<span class="advantage__cell advantage__cell--icon advantage__cell--${icon.tone}${center}" style="--cell-i: ${i}">${icon.glyph}</span>`;
  }).join("");

  return `
    <div class="advantage__visual" aria-hidden="true">
      <div class="advantage__grid">${cells}</div>
      <span class="advantage__cursor">${cursorIcon}</span>
    </div>
  `;
}

function renderCard(card, index) {
  return `
    <article class="advantage__card reveal" style="--card-i: ${index}">
      <div class="advantage__copy">
        <span class="advantage__eyebrow"><span class="advantage__eyebrow-dot"></span>${card.eyebrow}</span>
        <h3 class="advantage__heading">${card.heading}</h3>
        <p class="advantage__subtitle">${card.subtitle}</p>
        <a class="btn btn--primary advantage__cta" href="${card.ctaHref}">${card.cta}</a>
        <div class="advantage__stats">
          ${card.stats
            .map(
              (stat) => `
            <div class="advantage__stat">
              <span class="advantage__stat-value">${stat.value}</span>
              <span class="advantage__stat-label">${stat.label}</span>
            </div>
          `
            )
            .join("")}
        </div>
      </div>
      ${renderVisual(card.icons)}
    </article>
  `;
}

export function createAdvantageSection() {
  const { advantage } = content;
  const section = document.createElement("section");
  section.id = "advantage";
  section.className = "section advantage";

  section.innerHTML = `
    <div class="section__inner">
      <div class="advantage__intro reveal">
        ${buildSectionPillRow(advantage.badge)}
        <h2 class="advantage__title">${buildAnimatedHeading(advantage.titleSegments)}</h2>
      </div>

      <div class="advantage__stack">
        ${advantage.cards.map(renderCard).join("")}
      </div>
    </div>
  `;

  return section;
}
